import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import { sendCode } from 'services/auth';

const UseSendCode = () => {
  const navigate = useNavigate();
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: ISendCodePayload) => {
      return sendCode(payload);
    },
    onSuccess: (_, variables) => {
      navigate('/auth/confirmation', {
        state: {
          mobile: variables?.mobile,
        },
      });
    },
  });

  return {isLoading, mutate};
};

export default UseSendCode;
